import { useContext, useEffect, useState } from 'react';
import { Subscription } from 'rxjs';

import { SocketContext } from '../providers/SocketProvider/SocketProvider';

const useVotes = (gameId: string, slideId: string, tenantId: string) => {
  const { gameAPI } = useContext(SocketContext);

  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let sub: Subscription | undefined;
    if (gameAPI) {
      sub = gameAPI.game
        .subscribeVotes({ gameId, slideId, tenantId })
        .subscribe(({ count }) => {
          setCount(count);
        });
    }

    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, [gameAPI, gameId, slideId, tenantId]);

  return {
    count,
  };
};

export default useVotes;
